/**
 *
 * ------------------------------------------------------------------------------------------
 */
export default function usePlaces() {
    const { t: $t } = useNuxtApp().$i18n;
    /**
     * Resolve an array of place URNs to Place objects via apiLoadPlaceName.
     * Falls back to a generic translated fallback name if the API call fails.
     */
    async function resolvePlaceNames(urns: string[]): Promise<Place[]> {
        const fallbackName = $t('offerFlow.productConfigPresets.placeName.fallback');
        const results = await Promise.all(
            urns.map(async (urn) => {
                try {
                    const result = await apiLoadPlaceName(urn);
                    return { ref: urn, name: result.data || fallbackName };
                }
                catch {
                    return { ref: urn, name: fallbackName };
                }
            }),
        );
        return results;
    }

    return {
        resolvePlaceNames,
    };
}
